import React, { useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Form, FormGroup, Input, Label } from "reactstrap";
import FormikErrorMessage from "../../../../../../../common/FormikErrorMessage";
import { useFormik } from "formik";
import { AccountSettingSchema } from "../../../../../../../common/ValidationSchemas/AccountSettingSchema";
import avatar from "../../../../../../../images/avatar.png";
import Camera from "../../../../../../../images/camera@3x.png";
import { logout, updateProfile } from "../../../../../../../redux/actions/user";
import { getKeycloackToken } from "../../../../../../../redux/actions/auth";
import axios from "axios";
import Select from "react-select";
import PhoneInput from 'react-phone-number-input'
import 'react-phone-number-input/style.css'
import { changeActiveTab } from "../../../../../../../redux/actions/skill";
import { notify } from "../../../../../../../redux/actions/snack";
import $ from "jquery";
import EXIF from 'exif-js';
import exifr from "exifr";

// import 'react-phone-number-input/style.css'
// import PhoneInput from 'react-phone-number-input'

const AccountSetting = () => {
  const userDetails = useSelector((state) => state.userReducer.user);
  const dispatch = useDispatch();

   const [value, setValue] = useState("");
   
  useEffect(() => {
    setValue(userDetails?.contactNumber);
  }, [userDetails]);

  //const options = useMemo(() => PhoneInput().getData(), []);
  const changeHandler = (value) => {
    setValue(value.label);
  };
  
  const {
    values,
    errors,
    touched,
    isSubmitting,
    handleSubmit,
    handleChange,
    handleBlur,
    resetForm,
    setFieldValue,
  } = useFormik({
    initialValues: {
      firstName: userDetails ? userDetails.given_name : "",
      lastName: userDetails ? userDetails.family_name : "",
      email: userDetails ? userDetails.email : "",
      contactNumber: userDetails ? userDetails.contactNumber : "",
      profilePic: userDetails ? userDetails.profilePic : "",
      // country: userDetails ? userDetails.country : "",
    },
    enableReinitialize: true,
    validationSchema: AccountSettingSchema,
    onSubmit: async (values) => {
      const { firstName, lastName, country, phoneInput, profilePic } =
        values;
      const payload = {
        firstName,
        lastName,
        attributes: {
          profilePic,
          // country: value,
          contactNumber:value,
          subscription_id: 1,
          check_plan: "",
          check_user: true,
          role: "",
          organizationId: userDetails?.organizationId
        },
      };
      await dispatch(updateProfile(payload));
    },
    
  });

  $('input#profile').bind('change', function() {
    var maxSizeKB = 20; 
    var maxSize = maxSizeKB * 1024;
    if (this.files[0].size > maxSize) {
      $(this).val("");
      dispatch(notify("error", "Size must be equal to or less than 20KB." ))
      return false;
    }
  });

  const handleFileChange = async (e) => {
    try {
      let token = await getKeycloackToken();
      const file = e.target.files[0]; 
      // Validate file format on the frontend
      const fileExt = file.name.split(".").pop().toLowerCase();
      const allowedFormats = ["jpeg", "gif", "png", "jpg", "jfif", "pjpeg", "pjp", "apng", "blob"];
      if (!allowedFormats.includes(fileExt)) {
        throw new Error("Incorrect File Format");
      }
      // Function to remove metadata from JPEG files
      const removeMetadataFromJPEG = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = function(event) {
            let dataUrl = event.target.result;
  
            // Remove EXIF data using exif-js
            const img = new Image();
            img.onload = function() {
              EXIF.getData(img, function() {
                const allMetaData = EXIF.getAllTags(this);
              
                // Create canvas and copy image without EXIF data
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                canvas.toBlob(function(blob) {
                  
                  resolve(blob);
                }, file.type);
              });
            };
            img.src = dataUrl;
          };
          reader.onerror = reject;
          reader.readAsDataURL(file);
        });
      };
  
      // Function to remove metadata from PNG files using exifr
      const removeMetadataFromPNG = async (file) => {
        try {
          // Read the image file using exifr to handle metadata removal
          const metadata = await exifr.parse(file);
          // Create a new Blob without metadata 
          const strippedBlob = file.slice(0, file.size, file.type);
          return strippedBlob;
        } catch (error) {
          console.error('Error removing PNG metadata:', error);
          throw error;
        }
      };
      let strippedBlob;
      if (fileExt === "jpeg" || fileExt === "jpg" || fileExt === "jfif" || fileExt === "pjpeg" || fileExt === "pjp") {
        strippedBlob = await removeMetadataFromJPEG(file);
      } else if (fileExt === "png" || fileExt === "apng") {
        strippedBlob = await removeMetadataFromPNG(file);
      } else {
        strippedBlob = file;
      }

      var data = new FormData();
      data.append("file", strippedBlob, `file.${fileExt}`); // Append with the original extension
      var config = {
        url: `${process.env.REACT_APP_BOT_SERVICE_URL}/upload/profile-image`,
        method: "post",
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
        data: data,
      };
      const res = await axios(config);
      if (res.data && res.data.data && res.data.data.image_id) {
        const imgId = res.data.data.image_id;
        let url = `${process.env.REACT_APP_BOT_SERVICE_URL}/image/${imgId}`;
        setFieldValue("profilePic", url);
        handleSubmit();
      } else {
        console.error("Invalid response format from upload:", res.data);
      }
    } catch (err) {
      console.error("Error fetching/uploading image:", err.message);
    }
  };
  
  const openDeleteModal = async () => {
    window.jQuery("#deleteFlow").modal({ show: true });
  };
  const handleDeleteUser = async () => {
    try {
      let token = await getKeycloackToken();

      var config = {
        url: `${process.env.REACT_APP_BOT_SERVICE_URL}/user/deleteUser`,
        method: "delete",
        headers: {
          // "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        // data: data,
      };

      const res = await axios(config);

      if (res.status) {
        dispatch(changeActiveTab("Settings"));
        dispatch(logout());
      }
    } catch (err) {
      console.log(err.toString());
    }
  };
  
  return (
    <>
     <div className="modal fade qa-modal1" id="deleteFlow" role="dialog">
        <div className="modal-dialog modal-sm">
          <div className="modal-content share-modal">
            <button type="button" className="close" data-dismiss="modal">
              &times;
            </button>
            <div className="modal-body">
              <h3 className="qa-modal-title">Delete Account</h3>
              <div>
                <h5>
                  The user will be permanently deleted. Do you want to proceed?
                </h5>
              </div>

              <div className="frm-btns fb-right">
                <button
                  className="btn-outline"
                  data-dismiss="modal"
                  onClick={() => {
                  }}
                >
                  Cancel
                </button>
                <button
                  className="btn-primary"
                  data-dismiss="modal"
                  onClick={() => {
                    handleDeleteUser();
                  }}
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row d-flex">
        <div className="col-lg-9 ">
          <div className="card org-profile-card border-0">
            <div className="row  org-profile-content">
              <div className="col-sm-12 col-lg-6 offset-xl-3">
                <Form noValidate onSubmit={handleSubmit}>
                  <div>
                    <FormGroup>
                      <div className="ip-tl-label">
                        <span className="tl-label">First Name</span>
                        <Input
                          type="text"
                          name="firstName"
                          placeholder="Enter First Name"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.firstName}
                        />
                        <FormikErrorMessage
                          errors={errors}
                          touched={touched}
                          field="firstName"
                        />
                      </div>
                      {/* <Label>First Name</Label>
                      <Input
                        type="text"
                        name="firstName"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.firstName}
                      />
                      <FormikErrorMessage
                        errors={errors}
                        touched={touched}
                        field="firstName"
                      /> */}
                    </FormGroup>
                    <FormGroup>
                      <div className="ip-tl-label">
                        <span className="tl-label">Last Name</span>
                        <Input
                          type="text"
                          name="lastName"
                          placeholder="Enter Last Name"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.lastName}
                        />
                        <FormikErrorMessage
                          errors={errors}
                          touched={touched}
                          field="lastName"
                        />
                      </div>
                      {/* <Label> Last Name</Label>
                      <Input
                        type="text"
                        name="lastName"
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.lastName}
                      />
                      <FormikErrorMessage
                        errors={errors}
                        touched={touched}
                        field="lastName"
                      /> */}
                    </FormGroup>
                    <FormGroup>
                      <div className="ip-tl-label">
                        <span className="tl-label">Email Address</span>
                        <Input
                          type="text"
                          name="email"
                          placeholder="Enter Email"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          value={values.email}
                          disabled
                        />
                        <FormikErrorMessage
                          errors={errors}
                          touched={touched}
                          field="email"
                        />
                      </div>
                    </FormGroup>
                      <FormGroup>
                        <div className="ip-tl-label">
                          <span className="tl-label">Phone Number</span>
                          <PhoneInput
                            className="form-control"
                            international
                            countryCallingCodeEditable={false}
                            placeholder="Enter Phone Number"
                            id="phoneInput"
                            name="phoneInput"
                            onChange={setValue}
                            onBlur={handleBlur}
                            value={values.contactNumber}
                          />
                        </div>
                      </FormGroup>
                    <div className="mt-4 mt-auto text-right">
                      <button type="submit" className="btn btn-primary">
                        Update
                      </button>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-3">
          <div className="card org-profile-card border-0 text-center">
            <div className="upld-avatar m-auto">
              <img
                src={values.profilePic ? values.profilePic : avatar}
                alt="Avatar"
              />
              <div
                onClick={() => document.getElementById("profile").click()}
                className="upld-hover"
              >
                <img src={Camera} alt="camera" />
                <input
                  type="file"
                  accept="image/*"
                  id="profile"
                  style={{ display: "none" }}
                  onChange={(e) => handleFileChange(e)}
                />
              </div>
            </div>
            <div className="my-3">
              <p className="font-weight-600 mb-0">Profile Photo</p>
              {/* <span className="text-muted f-12">20kb max</span> */}
            </div>
            <div className="delete-profile-setting">
              <button
                className="btn btn-primary-danger mt-auto"
                data-dismiss="modal"
                onClick={() => openDeleteModal()}
              >
                Delete Account
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default AccountSetting;
